export type CurrencyFormat = 'anglo-american' | 'locale';
export type CurrencyDisplay = 'symbol' | 'code';

export const DEFAULT_CURRENCY_FORMAT: CurrencyFormat = 'anglo-american';
export const DEFAULT_CURRENCY_DISPLAY: CurrencyDisplay = 'symbol';

export const LANG_TO_LOCALE: Record<string, string> = {
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  pt: 'pt-PT',
  ca: 'ca-ES',
};

export const CURRENCY_FORMATS = [
  { id: 'anglo-american', value: 'common:currencyFormatAngloAmerican' },
  { id: 'locale', value: 'common:currencyFormatLocaleBased' },
] as const;

export const CURRENCY_DISPLAYS = [
  { id: 'symbol', value: 'common:currencyDisplaySymbol' },
  { id: 'code', value: 'common:currencyDisplayCode' },
] as const;
